var _circle, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapLive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 76,
    viewBox: "0 0 72 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 17,
    fill: "url(#paint0_linear_7339_4352)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 29.634C38.1667 30.0189 38.1667 30.9811 37.5 31.366L27.75 36.9952C27.0833 37.3801 26.25 36.899 26.25 36.1292V24.8708C26.25 24.101 27.0833 23.6199 27.75 24.0048L37.5 29.634Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7339_4352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1835 60.6648H15.7278C8.2825 60.6648 2.24683 54.6293 2.24683 47.1838V15.7281C2.24683 8.28275 8.2825 2.24707 15.7278 2.24707H47.1835C54.6291 2.24707 60.6646 8.28275 60.6646 15.7281V22.6964",
    stroke: "url(#paint1_linear_7339_4352)",
    strokeWidth: 3.5443,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4358 55.699L55.74 32.8088C55.9808 32.3213 56.4774 32.0127 57.0211 32.0127H67.4475C68.5643 32.0127 69.2494 33.2365 68.6654 34.1886L60.6716 47.2216C60.0877 48.1737 60.7728 49.3975 61.8896 49.3975H66.9698C68.1777 49.3975 68.8407 50.8034 68.0721 51.7354L49.2619 74.5459C48.2238 75.8047 46.2265 74.6203 46.8332 73.1056L52.1943 59.7206C52.5702 58.7819 51.879 57.7605 50.8679 57.7605H45.7169C44.6578 57.7605 43.9668 56.6486 44.4358 55.699Z",
    fill: "url(#paint2_linear_7339_4352)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7339_4352",
    x1: 39.5,
    y1: 6.5,
    x2: 23.5,
    y2: 56.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#803AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475962,
    stopColor: "#EA489A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8F3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7339_4352",
    x1: 31.4557,
    y1: 2.24707,
    x2: 31.4557,
    y2: 60.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#803AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475962,
    stopColor: "#EA489A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8F3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7339_4352",
    x1: 60.7388,
    y1: 32.0127,
    x2: 46.8057,
    y2: 81.5947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD3790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#248ECC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7339_4352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.9114,
    height: 62.9114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapLive);
export default __webpack_public_path__ + "static/media/zap-live.65310da5196c9ba6cf52d3e831e231b9.svg";
export { ForwardRef as ReactComponent };